import { InvoiceStatus } from "../enums";
import { SystemColor, SystemColorsModel } from "../models";

export class InvoiceUtil {
  static getColorsByStatus(status: keyof typeof InvoiceStatus): SystemColor {
    let colors = SystemColorsModel.lightGreyColors();
    switch (status) {
      case "Open":
        colors = SystemColorsModel.lightBlueColor();
        break;
      case "Paid":
        colors = SystemColorsModel.ligthGreenColors();
        break;
      case "PastDue":
      case "Uncollectible":
        colors = SystemColorsModel.lightRedColor();
        break;
    }
    return colors;
  }
}
